/**
 * Created by Administrator on 2018/6/13.
 */
const state = {
  common: {
    loop: [
      //跳转链接 link ;跳转路由 router;不跳转 router:'/home'
      {
        name: 'diamondMallActive',
        startTime: 0,
        endTime: 4102416000000,
        img: 'http://image.shrongyikeji.com/manager/diamonMall/diamondLoop.png',
        link: './active/diamondMall.html'
      },
      {
        startTime: 0,
        endTime: 4102416000000,
        img: 'http://image.shrongyikeji.com/member/notice_green.jpeg',
        router: '/home'
      }
    ]
  },
  js3mj: {
    loop: [],
    district: [
      {
        label: '灌云',
        value: '灌云'
      },
      {
        label: '沭阳',
        value: '沭阳'
      },
      {
        label: '东海',
        value: '东海'
      },
      {
        label: '新浦',
        value: '新浦'
      },
      {
        label: '泗阳',
        value: '泗阳'
      },
      {
        label: '宿迁',
        value: '宿迁'
      },
      {
        label: '赣榆',
        value: '赣榆'
      },
      {
        label: '灌南',
        value: '灌南'
      }
    ]
  },
  xuzhou: {
    loop: [],
    district: [
      {
        label: '徐州',
        value: '徐州'
      }
    ]
  },
  huaian: {
    loop: [],
    district: [
      {
        label: '淮安',
        value: '淮安'
      }
    ]
  },
  haian: {
    loop: [],
    district: [
      {
        label: '海安',
        value: '海安'
      }
    ]
  },
  yongzhou: {
    loop: [],
    district: [
      {
        label: '零陵',
        value: '零陵'
      },
      {
        label: '冷水滩',
        value: '冷水滩'
      },
      {
        label: '双牌',
        value: '双牌'
      },
      {
        label: '祁阳',
        value: '祁阳'
      },
      {
        label: '东安',
        value: '东安'
      },
      {
        label: '道县',
        value: '道县'
      },
      {
        label: '宁远',
        value: '宁远'
      },
      {
        label: '新田',
        value: '新田'
      },
      {
        label: '蓝山',
        value: '蓝山'
      },
      {
        label: '江永',
        value: '江永'
      },
      {
        label: '江华',
        value: '江华'
      }
    ]
  },
  leiyang: {
    loop: [],
    district: [
      {
        label: '耒阳',
        value: '耒阳'
      },
      {
        label: '常宁',
        value: '常宁'
      }
    ]
  },
  yueyang: {
    loop: [],
    district: [
      {
        label: '岳阳',
        value: '岳阳'
      },
      {
        label: '浏阳',
        value: '浏阳'
      },
      {
        label: '望城',
        value: '望城'
      },
      {
        label: '郴州',
        value: '郴州'
      },
      {
        label: '桂阳',
        value: '桂阳'
      },
      {
        label: '宜章',
        value: '宜章'
      },
      {
        label: '株洲',
        value: '株洲'
      },
      {
        label: '宁乡',
        value: '宁乡'
      },
      {
        label: '醴陵',
        value: '醴陵'
      },
      {
        label: '攸县',
        value: '攸县'
      },
      {
        label: '茶陵',
        value: '茶陵'
      },
      {
        label: '株洲县',
        value: '株洲县'
      }
    ]
  },
  hubei: {
    loop: [],
    district: [
      {
        label: '湖北',
        value: '湖北'
      }
    ]
  },
  hengyang: {
    loop: [],
    district: [
      {
        label: '衡阳',
        value: '衡阳'
      }
    ]
  },
  jinzhong: {
    loop: [],
    district: [
      {
        label: '山西',
        value: '山西'
      },
      {
        label: '灵石',
        value: '灵石'
      },
      {
        label: '榆次',
        value: '榆次'
      },
      {
        label: '平遥',
        value: '平遥'
      },
      {
        label: '介休',
        value: '介休'
      },
      {
        label: '大同',
        value: '大同'
      },
      {
        label: '朔州',
        value: '朔州'
      },
      {
        label: '忻州',
        value: '忻州'
      },
      {
        label: '阳泉',
        value: '阳泉'
      },
      {
        label: '吕梁',
        value: '吕梁'
      },
      {
        label: '晋中',
        value: '晋中'
      },
      {
        label: '长治',
        value: '长治'
      },
      {
        label: '晋城',
        value: '晋城'
      },
      {
        label: '临汾',
        value: '临汾'
      },
      {
        label: '运城',
        value: '运城'
      }
    ]
  },
  shaoyang: {
    loop: [],
    kefu: '',
    appid: 'wx61ad1daf9703d584',
    district: [
      {
        label: '邵阳',
        value: '邵阳'
      },
      {
        label: '洞口',
        value: '洞口'
      },
      {
        label: '隆回',
        value: '隆回'
      },
      {
        label: '邵东',
        value: '邵东'
      },
      {
        label: '武冈',
        value: '武冈'
      },
      {
        label: '新宁',
        value: '新宁'
      },
      {
        label: '新邵',
        value: '新邵'
      },
      {
        label: '娄底',
        value: '娄底'
      },
      {
        label: '怀化',
        value: '怀化'
      },
      {
        label: '望城',
        value: '望城'
      }
    ]
  },
  xiangxiang: {
    loop: [],
    district: [
      {
        label: '湘乡',
        value: '湘乡'
      },
      {
        label: '湘潭',
        value: '湘潭'
      }
    ]
  },
  shanxi : {
    loop: [],
    district: [
      {
        label: '山西',
        value: '山西'
      },
      {
        label: '灵石',
        value: '灵石'
      },
      {
        label: '榆次',
        value: '榆次'
      },
      {
        label: '平遥',
        value: '平遥'
      },
      {
        label: '介休',
        value: '介休'
      },
      {
        label: '大同',
        value: '大同'
      },
      {
        label: '朔州',
        value: '朔州'
      },
      {
        label: '忻州',
        value: '忻州'
      },
      {
        label: '阳泉',
        value: '阳泉'
      },
      {
        label: '吕梁',
        value: '吕梁'
      },
      {
        label: '晋中',
        value: '晋中'
      },
      {
        label: '长治',
        value: '长治'
      },
      {
        label: '晋城',
        value: '晋城'
      },
      {
        label: '临汾',
        value: '临汾'
      },
      {
        label: '运城',
        value: '运城'
      }
    ]
  }
}
const mutations = {
  // var param={
  //    name:'',
  //    replaceImgUrl:''
  // }
  /**替换对应name的图片**/
  replaceImg(state, param) {
    for (var i = 0; i < state[localStorage.env].loop.length; i++) {
      if (param.name == state[localStorage.env].loop[i].name) {
        state[localStorage.env].loop[i].img = param.replaceImgUrl
      }
    }
  },
  // var param={
  //    name:'',
  // }
  /**删除对应name的图片（不包括公共轮播图）**/
  deleteImg(state, param) {
    // 删除公共部分某些图片
    for (var i = 0; i < state.common.loop.length; i++) {
      if (param.name == state.common.loop[i].name) {
        state.common.loop.splice(i, 1)
      }
    }
    // 删除对应地区某些图片
    for (var j = 0; j < state[localStorage.env].loop.length; j++) {
      if (param.name == state[localStorage.env].loop[j].name) {
        state[localStorage.env].loop.splice(j, 1)
      }
    }
  },
  /**删除不在时间范围内的图片**/
  deleteImgOutTime(state, serverTime) {
    // 删除公共轮播图过期图片
    for (var i = 0; i < state.common.loop.length; i++) {
      if (
        serverTime < state.common.loop[i].startTime ||
        serverTime > state.common.loop[i].endTime
      ) {
        state.common.loop.splice(i, 1)
      }
    }
    //删除对应地区过期图片
    for (var j = 0; j < state[localStorage.env].loop.length; j++) {
      if (
        serverTime < state[localStorage.env].loop[j].startTime ||
        serverTime > state[localStorage.env].loop[j].endTime
      ) {
        state[localStorage.env].loop.splice(j, 1)
      }
    }
  },
  /**在轮播图最后面添加图片**/
  addImg(state, param) {
    // param={
    //   startTime:'',
    //   endTime:'',
    //   img:'',
    //   target:'',// router or link
    //   targetUrl:''
    // }
    var obj = {}
    obj.startTime = param.startTime
    obj.endTime = param.endTime
    obj.img = param.img
    obj[param.target] = param.targetUrl

    for (var i = 0; i < state[localStorage.env].loop.length; i++) {
      if (state[localStorage.env].loop[i].img == param.img) {
        state[localStorage.env].loop.splice(i, 1) //先删后增避免每次push
      }
    }
    state[localStorage.env].loop.push(obj)
  },
  //在轮播图最前面添加图片
  unshiftImg(state, param) {
    // param={
    //   startTime:'',
    //   endTime:'',
    //   img:'',
    //   target:'',// router or link
    //   targetUrl:''
    // }
    var obj = {}
    obj.startTime = param.startTime
    obj.endTime = param.endTime
    obj.img = param.img
    obj[param.target] = param.targetUrl
    for (var i = 0; i < state[localStorage.env].loop.length; i++) {
      if (state[localStorage.env].loop[i].img == param.img) {
        state[localStorage.env].loop.splice(i, 1) //先删后增避免每次push
      }
    }
    state[localStorage.env].loop.unshift(obj)
    console.log(state[localStorage.env].loop)
  }
}
const actions = {}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/envData.js